import { createUseStyles, useTheme } from 'react-jss'
import style from './style'
import {
  TypographyElement,
  Icon,
  Icons,
  Skeleton
} from 'UI'
import Text from './text.json'

const useStyle = createUseStyles(style)

export default ({
  Image,
  showPopUp,
  Id,
  loading
}) => {
  const theme = useTheme()
  const {
    bannerGroup,
    skeleton,
    overlay,
    playSection,
    playIcon,
    playIconGroup
  } = useStyle({ Image, loading })

  return loading
    ? (
      <div className={bannerGroup}>
        <Skeleton className={skeleton} lines={1} width='100%' height='100%' />
      </div>)
    : (
      <div className={bannerGroup} key={`${Id}-${loading}`}>
        <div className={overlay}>
          <div className={playSection} onClick={() => showPopUp(true)}>
            <div className={playIconGroup}><Icon iconName={Icons.play} style={playIcon} /></div>
            <TypographyElement
              variant='body1'
              color={theme.neutral[400]}
            >
              {Text.takealook}
            </TypographyElement>
          </div>
        </div>
      </div>
      )
}
